import { ElementSelector } from "../../../dom-tools/ElementSelector";
import { ElementSelectors } from "../../../dom-tools/ElementSelectors";
import { ElementType } from "../../../dom-tools/ElementType";
import { DateSorter } from "./DateSorter";
import { TextSorter } from "./TextSorter";
import { Sorter } from "./Sorter";

export class SorterFactory
{
  static create( e: Element): Sorter
  {
    let sorterSetting = Sorter.setting.query( e );
    
    if ( ! sorterSetting )
    {
      return null;
    }

    let reverseInput = ElementSelectors.inputCheckBox.query( Sorter.reverse.query( sorterSetting ) ); 

    let reverse = reverseInput && reverseInput.checked;

    
    let select =  ElementType.select.query( sorterSetting );
    let options = ElementType.option.queryAll( select );


    let selectedElement = options[ select.selectedIndex ];
    
    if ( DateSorter.type.in( selectedElement ) )
    {
      return new DateSorter( selectedElement, reverse );
    }

    if ( TextSorter.type.in( selectedElement ) )
    {
      return new TextSorter( selectedElement, reverse );
    }

    return null;
  } 
}